import { render, staticRenderFns } from "./ModifyComparesion.vue?vue&type=template&id=1b562360&scoped=true"
import script from "./ModifyComparesion.vue?vue&type=script&lang=js"
export * from "./ModifyComparesion.vue?vue&type=script&lang=js"
import style0 from "./ModifyComparesion.vue?vue&type=style&index=0&id=1b562360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b562360",
  null
  
)

export default component.exports